// extracted by mini-css-extract-plugin
export default {"mobileFS":"manager_mobileFS__VWu+5","stickyThead":"manager_stickyThead__XIt2e"};